import { render, staticRenderFns } from "./UnidadeMedidaArea.vue?vue&type=template&id=38742e30"
import script from "./UnidadeMedidaArea.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports